﻿(function () {
    function oauthPopup(options) {
        var name = options.windowName || 'ConnectWithOAuth';
        var features = options.windowOptions || 'type=display';
        var cb = options.callback || function () { window.location.reload(); };

        var popup = window.open(options.path, name, features);
        var interval = window.setInterval(function () {
            if (!popup || popup.closed) {
                window.clearInterval(interval);
                cb();
            }
        }, 1000);
    }

    window.setUpExternalAuth = function (redirectUrl) {
        document.querySelectorAll('form[name="external-auth"]').forEach(function (form) {
            form.addEventListener('submit', function (e) {
                e.preventDefault();
                oauthPopup({
                    path: redirectUrl,
                    callback: function () {
                        console.log('oauth popup closed');
                        window.location.reload();
                    }
                });
            });
        });
    };
})();
